import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
import order_fail from '../../../utilities/images/failed-payment.svg'

import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { reduxForm } from 'redux-form'
import {
  getDataFromSuccessResponse,
  getErrorFromFailResponse
} from '../../../utilities/function/apiResponse'

import {
  getDataFromURL
} from "../../../utilities/function/urlparams"

import globalCookies from '../../../utilities/function/cookies'

import PaymentOptions, { NEW_CREDIT_CARD, PAYPAL, SAVED_CREDIT_CARD } from '../../shared/paymentoptions'

import ACCOUNT_API from '../../../utilities/api/account'
import CHECKOUT_API from '../../../utilities/api/checkout'
import { updateFinished, updatePopupNotification } from '../../../app/action'
import Loading from '../../shared/loading'



const getOrderFailURL = () =>{
  let url = order_fail
  if(window.app_config && window.app_config.payment_failed_icon){
    url = window.app_config.payment_failed_icon
  }
  return url
}

let PayInvoiceForm = (props) => {
  const { handleSubmit, form, dispatch, history, location } = props
  const [getUser, setGetUser] = useState({})
  useEffect(() => {
    const access_token = globalCookies.get('access_token')
    if (access_token && getUser.status === undefined) {
      setGetUser({
        ...getUser,
        status: 'loading',
      })
      ACCOUNT_API.setAccessToken(access_token)
      ACCOUNT_API.getUser().then(successresponse => {
        const data = getDataFromSuccessResponse(successresponse)
        setGetUser({
          ...getUser,
          status: 'success',
          data
        })
      }, errorresponse => {
        const error = getErrorFromFailResponse(errorresponse)
        setGetUser({
          ...getUser,
          status: 'error',
          error
        })
        window.setTimeout(() => {
          history.push(history.location.pathname)
        }, 300)
      })
    }
  }, [getUser, history, location])
  const renderText = () => {
    if (getUser.status === 'success' && getUser.data && getUser.data.attributes) {
      const { last_login, password_updated_at } = getUser.data.attributes

      if (last_login) {
        return (
          <div className={'of-checkout-orderfail__heading text-font-1-100'}>We were unable to take the payment.<br/>Please
            try an
            alternative method.</div>
        )
      } else {
        if (password_updated_at && moment(password_updated_at, 'YYYY-MM-DD HH:mm:ss')) {
          const createdObj = moment(password_updated_at, 'YYYY-MM-DD HH:mm:ss')
          const nowObj = moment()
          if (nowObj.diff(createdObj) > 120000) {
            return (
              <div className={'of-checkout-orderfail__heading text-font-1-100'}>We were unable to take the payment.<br/>Please
                try an
                alternative method.</div>
            )
          }
        }
      }
      return (
        <div className={'of-checkout-orderfail__heading text-font-1-100'}>Your account has been created however we were
          unable to take
          the payment.<br/>Please try an alternative method.</div>
      )
    }
    return (<></>)
  }
  return (
    <>
      <img src={getOrderFailURL()} alt={'Order Fail'} className={'of-checkout-orderfail__image'}/>
      {renderText()}
      <form onSubmit={handleSubmit}>
        <PaymentOptions getUser={getUser} form={form} dispatch={dispatch} isPayInvoice={true}/>
      </form>
    </>
  )
}

PayInvoiceForm = withRouter(PayInvoiceForm)

PayInvoiceForm.propTypes = {
  handleSubmit: PropTypes.func,
  form: PropTypes.any,
  dispatch: PropTypes.any,
  history: PropTypes.any,
  location: PropTypes.any
}

PayInvoiceForm = reduxForm({
  form: 'PaymentForm'
})(PayInvoiceForm)

let PayInvoice = (props) => {
  const { location, history } = props
  const { a, step, invoice_id, order_id } = getDataFromURL(location.search)
  const [requestPayInvoiceById, setRequestPayInvoiceById] = useState({})
  const { finished } = useSelector(state => ({
    finished: state.app.finished
  }))
  const handlePayInvoice = (values, dispatch) => {
    const { payment_option } = values

    let attributes = {}
    if (payment_option === NEW_CREDIT_CARD) {
      const { card_type, card_number, card_cvv, card_date, card_holder_name } = values
      const card_date_string = card_date.split('/')
      attributes = {
        payment_option,
        card_type,
        card_holder_name,
        card_number,
        card_month: card_date_string[0],
        card_year: card_date_string[1],
        card_cvv
      }
    } else if (payment_option === SAVED_CREDIT_CARD) {
      const { cc_id } = values
      attributes = {
        payment_option,
        cc_id
      }
    } else {
      attributes = {
        payment_option
      }
    }
    const payInvoicePayload = attributes
    const newFinished = {
      ...finished,
      payInvoicePayload,
      invoice_id,
      order_id
    }
    updateFinished(dispatch, newFinished)
    const instantPayment = () => {
      CHECKOUT_API.payInvoiceByID(invoice_id, attributes).then(successresponse => {
        const data = getDataFromSuccessResponse(successresponse)
        setRequestPayInvoiceById({
          ...requestPayInvoiceById,
          status: 'success',
          data
        })
        history.push(`${history.location.pathname}?a=checkout&step=finished`)
      }, errorresponse => {
        const error = getErrorFromFailResponse(errorresponse)
        const newPopupNotification = {
          status: 'error',
          error,
          data: null
        }
        updatePopupNotification(dispatch, newPopupNotification)
        setRequestPayInvoiceById({
          ...requestPayInvoiceById,
          status: 'error',
          error
        })
      })
    }
    const delayedPayment = () => {
        history.push(`${history.location.pathname}?a=checkout&step=finished`)
    }
    const paypalPayment = () => {
      const { cart_token } = newFinished
      const payload = {
        payment_option,
        token: cart_token
      }
      CHECKOUT_API.payInvoice(payload).then(successresponse => {
        const data = getDataFromSuccessResponse(successresponse)
        if (data && data.url) {
          window.location.href = data.url
        } else {
          history.push(`${history.location.pathname}?a=checkout&step=finished`)
        }
      }, errorresponse => {
        const error = getErrorFromFailResponse(errorresponse)
        const newPopupNotification = {
          status: 'error',
          error,
          data: null
        }
        updatePopupNotification(dispatch, newPopupNotification)
        setRequestPayInvoiceById({
          ...requestPayInvoiceById,
          status: 'error',
          error
        })
      })
    }
    setRequestPayInvoiceById({
      ...requestPayInvoiceById,
      status: 'loading'
    })
    if (payment_option === NEW_CREDIT_CARD || payment_option === SAVED_CREDIT_CARD) {
      instantPayment()
    } else {
      if (payment_option === PAYPAL) {
        paypalPayment()
      } else {
        delayedPayment()
      }
    }
  }
  if (a === 'checkout' && step === 'payinvoice' && invoice_id && order_id) {
    return (
      <>
        <div className={`of-checkout-payment clearfix${requestPayInvoiceById.status==="loading"?' of-checkout-payment--loading':''}`}>
          <div className={'of-checkout-orderfail'}>
            <PayInvoiceForm onSubmit={handlePayInvoice}/>
          </div>
        </div>
        {requestPayInvoiceById.status === 'loading' ? <Loading wrapper={true}/> : <></>}
      </>
    )
  }
  return (<></>)
}

PayInvoice.propTypes = {
  location: PropTypes.any,
  history: PropTypes.any
}

PayInvoice = withRouter(PayInvoice)

export default PayInvoice